export const getParams = (...params) => {
    const urlParams = new URLSearchParams(location?.search);
    const result = {};
    params.forEach((param) => {
        const searchParam = urlParams.get(param);
        result[param] = searchParam || "";
    });
    return result;
};
//# sourceMappingURL=getParams.js.map